import { css } from "@agapi/ui/panda/css";

export const formStyles = css.raw({
  position: 'absolute',
  bottom: '-33px',
  width: 'calc(100% - (token(spacing.app) * 2))',
  zIndex: 55,
  xl: {
    position: 'relative',
    bottom: '0',
    width: 'containers.sm'
  },
  lg: {
    position: 'relative',
    bottom: '0',
    width: 'containers.xs'
  },
  md: {
    position: 'relative',
    bottom: '0',
    width: 'containers.xs'
  },
  sm: {
    position: 'relative',
    bottom: '0',
    flex: 1,
    width: '100%'
  }
});

export const searchOverlayStyles = css.raw({
  pt: '4',
  sm: {
    pt: '2'
  }
});

export const menuStyles = css.raw({
  pt: '4',
  sm: {
    pt: '2'
  }
});

export const innerContainerStyles = css.raw({
  pt: '4',
  sm: {
    pt: '2'
  }
});

export const searchResultStyles = css.raw({
  display: 'grid',
  gridTemplateAreas: {
    base: `
          'suggestions'
          'products'
          'categories'
          'brands'
          'blog'
          'spacer'
      `,
    md: `
          'suggestions products'
          'categories  products'
          'brands      products'
          'blog        products'
          'spacer      products'
      `
  },
  gridAutoColumns: {
    md: '250px 1fr'
  },
  gridAutoRows: {
    md: 'auto auto auto auto 1fr'
  },
  pt: 4,
  gridRowGap: 5,
md: {
    gap: 4
  }
});
